import { Component } from 'react'
import PropTypes from 'prop-types'
import ArticleSample from './ArticleSample'
import { graphqlFetch, sortPropFn } from '../../cdl-react-components/utilities'

class ArticleSamples extends Component {
    state = { samples: [] }

    static defaultProps = { 
        group: 'All'
    }

    render() {
        return (
            <div className="article-samples">
                { this.state.samples
                    .sort(sortPropFn('order'))
                    .map((sample, i) =>
                        <ArticleSample 
                            key={'article-sample__item--' + i}
                            sample={sample} /> )}
            </div>
        )
    }

    componentDidMount() {                
        graphqlFetch('wcms3', `
            query {
              articleSamples (
                order: { order: ASC }
                take: 100
              ) {
                samples: items {
                  id
                  title
                  synopsis
                  order                  
                  sample_article: sampleArticle {
                    id
                    title
                    pdf
                    thumbnails
                  }
                }
              }
            }`)
            .then(res => this.setState({ samples: res.data.articleSamples.samples }))
    }
}

ArticleSamples.propTypes = {
    group: PropTypes.string
}

export default ArticleSamples